import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface TranslationMissingDotProps {
    tooltipText: string;
}

const TranslationMissingDot: React.FC<TranslationMissingDotProps> = ({ tooltipText }) => {
    return (
        <OverlayTrigger placement="bottom" overlay={<Tooltip>{tooltipText}</Tooltip>}>
            <span
                className="d-inline-block rounded-circle bg-danger align-middle m-1 ms-2"
                style={{ width: 6, height: 6, padding: "3px" }}
            />
        </OverlayTrigger>
    );
};

export default TranslationMissingDot;
